module.exports = __webpack_public_path__ + "fonts/TheMix_cls_TT5_.9e21e169.eot";